export default "__VITE_ASSET__DYBLVBRS__"